import MachineVerhuur from "./MachineVerhuur";

export default MachineVerhuur;